var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 71,
    viewBox: "0 0 84 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Decorative picto/savings",
    clipPath: "url(#clip0_40_5403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 133",
    d: "M34.5579 20.6479C37.0381 19.2939 39.885 18.524 42.9128 18.524C45.3175 18.524 47.6087 19.0095 49.6923 19.8882",
    stroke: "#007644",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 134",
    d: "M17.7839 29.7636C17.7839 27.79 19.3887 26.19 21.369 26.19C23.3488 26.19 24.9536 27.79 24.9536 29.7636",
    stroke: "#007644",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 135",
    d: "M81.1381 17.225C80.6279 16.2768 79.4231 15.9412 78.4673 16.4423L72.2176 19.7168C66.1089 11.4187 55.4361 5.91494 43.2807 5.91494C39.4798 5.91494 35.8272 6.46059 32.4093 7.45364C30.3544 3.53628 25.8336 1.35397 21.3297 2.44021C20.4943 2.64187 19.9743 3.48251 20.1773 4.31484L22.1168 12.2763C16.5206 16.0951 12.3213 21.3894 10.2874 27.4906H5.0497C3.36151 27.4906 1.99292 28.8551 1.99292 30.5379V42.7831C1.99292 44.4658 3.36151 45.83 5.0497 45.83H10.7248C10.7248 45.83 13.6269 52.4544 19.1057 57.1209V65.6617C19.1057 67.5001 20.6007 68.9903 22.4451 68.9903H30.7827C32.6271 68.9903 34.1221 67.5001 34.1221 65.6617V64.704C37.0392 65.4052 40.1077 65.7877 43.2807 65.7877C46.5076 65.7877 49.6267 65.3916 52.588 64.6672V65.6617C52.588 67.5001 54.083 68.9903 55.9274 68.9903H64.2649C66.1089 68.9903 67.6039 67.5001 67.6039 65.6617V56.9953C73.8065 51.5799 77.6421 44.106 77.6421 35.8515C77.6421 33.0843 77.2022 30.4085 76.3958 27.8652L78.1519 26.9448C81.6803 25.0962 83.0259 20.7335 81.1381 17.225L81.1381 17.225Z",
    stroke: "#007644",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 136",
    d: "M32.1909 7.065C32.1909 7.065 32.9871 7.90375 33.8493 10.7356",
    stroke: "#007644",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 137",
    opacity: 0.15,
    d: "M68.1652 31.977C66.7755 41.346 51.5373 48.727 32.9306 48.727C31.9967 48.727 31.0737 48.7026 30.158 48.666C34.1524 52.9384 40.378 55.6988 47.3923 55.6988C59.4507 55.6988 69.2262 47.5749 69.2262 37.5534C69.2262 35.6067 68.8481 33.735 68.1652 31.977H68.1652Z",
    fill: "#007644"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_5403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 71,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.494d7168acdea47de36b2cbdd4cd7228.svg";
export { ForwardRef as ReactComponent };